import React, { Component } from 'react';
import InputButton from '../../../../../../components/ZUILib/InputButton';
import Link from '../../../../../../components/ZUILib/Link';
import commonUtil from './../../../../../../utils/commonUtil';

export default class Body extends Component {
  addOwner = () => {
    this.props.switchToAddingNewCoOwner();
  }
  // getAdminLabel = (celebrity) => {
  //   if (celebrity.email && celebrity.title && celebrity.celebrityLabel) {
  //     return <p className="adminType">{celebrity.title} <span>(Administrador)</span></p>;
  //   } else if (celebrity.email && celebrity.celebrityLabel && !celebrity.title) {
  //     return <p className="adminType">{celebrity.celebrityLabel} <span>(Administrador)</span></p>;
  //   } else if (celebrity.celebrityLabel && celebrity.title && celebrity.title === 'Mr') {
  //     return <p className="adminType">{celebrity.celebrityLabel}</p>;
  //   }
  //   return <p className="adminType">{celebrity.title}</p>;
  // }
  getAdminLabel = (celebrity) => {
    if (celebrity.email && celebrity.title && celebrity.celebrityLabel) {
      return <p className="adminType">{celebrity.celebrityLabel} <span>(Administrador)</span></p>;
    } else if (celebrity.email && celebrity.celebrityLabel && !celebrity.title) {
      return <p className="adminType">{celebrity.celebrityLabel} <span>(Administrador)</span></p>;
    }
    return <p className="adminType">{celebrity.celebrityLabel}</p>;
  }

  getAdminTitle = (celebrity) => {
    if (celebrity.email && celebrity.title && celebrity.celebrityLabel) {
      return <p className="adminType">{celebrity.title} <span>(Administrador)</span></p>;
    } else if (celebrity.email && celebrity.celebrityLabel && !celebrity.title) {
      return <p className="adminType">{celebrity.celebrityLabel} <span>(Administrador)</span></p>;
    } else if (celebrity.celebrityLabel && !celebrity.title) {
      return <p className="adminType">{celebrity.celebrityLabel}</p>;
    }
    return <p className="adminType">{celebrity.title}</p>;
  }
  render() {
    const eventStatusForSuspended = this.props.eventStatusForSuspended;
    const selectedEventConfiguration = this.props.selectedEventConfiguration;
    const { eventDetailsInfo } = this.props;
    const celebrityInfo = eventDetailsInfo.celebrityInfo;
    const otherActiveEvents = (Object.keys(eventDetailsInfo.activeEventsInfo)).length;
    const otherEvents = {
      type: 'button',
      value: eventDetailsInfo.eventType,
      autoFocus: false,
      style: 'btnSecondarySpecial',
      onClickHandler: otherActiveEvents > 0 ? this.props.showOtherActiveEventSection : null,
      iconClass: otherActiveEvents > 0 ? 'icon-flecha_lightsvg_derecha' : null,
    };
    const linkForCreateNewEvent = {
      children: 'Crear nuevo evento',
      cssClass: 'specialLink',
      onClickHandler: this.props.checkEventEligibleToCreate,

    };
    return (
      <div className="myEventContent" >
        <div className="row admins">
          <h3>Festejados y Administradores</h3>
          {celebrityInfo.map((celebrity, id) => (
            <div className="col-xs-12" key={id} onClick={() => this.props.handleSelectedOwner(celebrity)}>
              <div className={celebrity.iscoOwner === 'true' ? 'adminBox notAdmin' : 'adminBox okAdmin'}>
                <div className="col-xs-10">
                  {/* {celebrity.celebrityLabel ? <p className="adminType">{commonUtil.sentenceCase(celebrity.celebrityLabel)} <span>(Administradora)</span></p> : null} */}
                  {selectedEventConfiguration.showTitle ? this.getAdminTitle(celebrity) : this.getAdminLabel(celebrity)}
                  {celebrity.firstName ? <p className="name">Nombre: <span>{commonUtil.sentenceCase(celebrity.firstName)} {commonUtil.sentenceCase(celebrity.lastName)}</span></p> : null}
                </div>
                <div className="col-xs-2"><i className="icon-flecha_lightsvg_derecha" /></div>
              </div>
            </div>
          ))}
        </div>
        {/* removed condition from below */}
        {(eventDetailsInfo.canAddOwner === 'true' && eventStatusForSuspended === false) ? <div className="row addAdminButton">
          <div className="col-xs-12">
            <a className="principalLink" onClick={this.addOwner} href="javascript:void(0)">
              <i className="iconRight icon-mas" /> Agregar administrador</a>
          </div>
        </div> : null}
        <div className="row adminButtons">
          <div className="col-xs-12">
            <Link linkJSON={linkForCreateNewEvent} >{linkForCreateNewEvent.children}</Link>
          </div>
          <div className="col-xs-12">
            <InputButton buttonAttr={otherEvents} />
          </div>
        </div>
      </div>
    );
  }
}

